import { render, staticRenderFns } from "./CountryBarChart.vue?vue&type=template&id=a22df70a&scoped=true&"
var script = {}
import style0 from "./CountryBarChart.vue?vue&type=style&index=0&id=a22df70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22df70a",
  null
  
)

export default component.exports